<template>
  <div>
    <div class="questionnaire-header">
      <div class="col-10">
        <div class="questionnaire-header-title">Raisonnement</div>
      </div>
      <div class="col-2 questionnaire-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>

    <div class="questionnaire-info">
      <p>Mettez-vous dans de bonnes conditions avant de commencer le test. <br>Une fois les {{ time }} minutes écoulées, vous ne pourrez plus accéder au test. </p>
      <p>Vous avez la possibilité de revenir sur les questions dans le temps imparti. </p>
    </div>

    <div class="questionnaire-section">
      <div class="questionnaire-section-header">
        <div class="questionnaire-section-header-main">Test de raisonnement</div>
        <div class="questionnaire-section-header-sub">{{ time }} minutes</div>
      </div>

      <div class="questionnaire-section-content">
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Abstrait</div>
          <div class="questionnaire-section-content-domain-time">20 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Logique</div>
          <div class="questionnaire-section-content-domain-time">20 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Verbal</div>
          <div class="questionnaire-section-content-domain-time">20 questions</div>
        </div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="emit('debuter', domainId)">
            <span>Commencer le test</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import UserService from "@/services/user.service";
import RouteEnum from "@/router/RouteEnum";

const router = useRouter();
const time = ref(90);
const domainId = 2;

defineProps({
  isDisabled: Boolean
});

const emit = defineEmits(['debuter']);

onMounted(() => {
  UserService.getUserTestContent().then(
    (response) => {
      const test = response.data.raisonnement;
      const thirdTime = response.data.thirdtime;
      if (thirdTime) {
        time.value = Math.ceil(time.value * 1.33);
      }
      if (test != null) router.push({ name: RouteEnum.CANDIDACY_TESTS });
    },
  );
});
</script>
